<template>
    <div>
        <el-date-picker
            v-on="$listeners"
            v-bind="$attrs"
            :type="type"
            range-separator="至"
            :picker-options="pickerOptions"
            ref="elDatePicker"
        >
        </el-date-picker>
    </div>
</template>
<script>
 import dayjs from 'dayjs'
 export default {
        name: 'datePickerSelector',
        props: {
           type:{
               type:String,
               default:'datetime',
           },
           timeRange:{
               type:Number,
               default:0
           },
           disabledFutureTime:{
               type:Boolean,
               default:false
           },
           initTime:{
                type:Array,
                default: () => [] ,
           },
           disabledStartDate: String,
           disabledEndDate: String,
           disabledFormerlyCount: Number,
            //时间选择器快捷键选项数组 today 今天，yesterday昨天，lastWeek最近一周，
            //currentMonth本月，lastMouths最近一个月，lastQuarter最近三月，year今年
            shortcutOptions:{
                type:Array,
                default: () => [] ,
            },
            propsPickerOptions: {
                type: Object,
                default () {
                    return {}
                }
            }
        },
        data() {
            return {
               curDate: '',
               datetimerangeOption:{
                   'today':{
                       text: '今天',
                        onClick(picker) {
                            const end = dayjs().endOf('day').$d ;
                            const start = dayjs().startOf('day').$d;
                            picker.$emit('pick', [start, end])
                        }
                   },
                   'yesterday':{
                       text: '昨天',
                        onClick(picker) {
                            const end = dayjs().endOf('day').$d;
                            const start = dayjs().startOf('day').$d;
                            start.setTime(start - 3600 * 1000 * 24 * 1);
                            end.setTime(end - 3600 * 1000 * 24 * 1);
                            picker.$emit('pick', [start, end]);
                        }
                   },
                   'lastWeek':{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            console.log(start,end)
                            picker.$emit('pick', [start, end]);
                        }
                   },
                   'currentMonth':{
                        text: '本月',
                        onClick(picker) {
                            const end = dayjs().endOf('day').$d ;
                            const start = dayjs().startOf('month').$d;
                            console.log(start,end)
                            picker.$emit('pick', [start, end]);
                        }
                   },
                    'lastMouths':{
                        text: '上月',
                        onClick(picker) {
                           const end = dayjs().subtract(1,'month').endOf('month').$d;
                           const start = dayjs().subtract(1,'month').startOf('month').$d;
                           picker.$emit('pick', [start, end]);
                        }
                   },
                //    'lastMouths':{
                //         text: '最近一个月',
                //         onClick(picker) {
                //             const end = new Date();
                //             const start = new Date();
                //             start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                //             picker.$emit('pick', [start, end]);
                //         },
                //    },
                   'lastQuarter':{
                       text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 93);
                            picker.$emit('pick', [start, end]);
                        },
                   },
                   'lastYear':{
                        text: '去年',
                        onClick(picker) {
                            const end = dayjs().subtract(1,'year').endOf('year').$d;
                            const start = dayjs().subtract(1,'year').startOf('year').$d;
                            picker.$emit('pick', [start, end]);
                        },
                   },
                   'year':{
                        text: '今年',
                        onClick(picker) {
                            const end = new Date();
                            const start = dayjs().startOf('year').$d;
                            picker.$emit('pick', [start, end]);
                        },
                   }
               },
               daterangeOption:{
                   'today':{
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    },
                    'yesterday':{
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    },
                    'lastWeek':{
                        text: '一周前',
                            onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }
               },
               monthrangeOption:{
                  'currentMonth': {
                        text: '本月',
                        onClick(picker) {
                            picker.$emit('pick', [new Date(), new Date()]);
                        }
                    },
                    'lastQuarter':{
                        text: '最近三月',
                        onClick(picker) {
                             const end = new Date();
                             const start = new Date();
                             start.setMonth(start.getMonth() - 3);
                             picker.$emit('pick', [start, end]);
                        }
                    },
                    'year':{
                        text: '今年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date(new Date().getFullYear(), 0);
                            picker.$emit('pick', [start, end]);
                        }
                     },
                    'lastYear':{
                        text: '去年',
                        onClick(picker) {
                            const end = new Date(new Date().getFullYear(), 11);
                            const start = new Date(new Date().getFullYear(), 0);
                            end.setFullYear(end.getFullYear()-1)
                            start.setFullYear(start.getFullYear()-1)
                            picker.$emit('pick', [start,end]);
                        }
                     },
               },
               pickerOptions: {
                    onPick: ({ maxDate, minDate }) => {
                        this.curDate = minDate.getTime()
                        if (maxDate) {
                            this.curDate = ''
                        }
                    },
                    disabledDate: (time) => {
                        if(this.type == 'datetimerange'||this.type == 'daterange'){
                           if(this.timeRange){
                                var one = 24 * 3600 * 1000 * this.timeRange//可选时间区间
                                var minTime = this.curDate - one
                                var maxTime = this.curDate + one
                                if(this.curDate) {
                                    return  this.isDisabledDate(time) ||(time.getTime() < minTime || time.getTime() > maxTime) 
                                }else{
                                    return this.isDisabledDate(time)
                                }
                           }else{
                               return this.isDisabledDate(time);
                           }
                        }else{
                            return this.isDisabledDate(time);
                        }
                    }
                },
                value:'',
            }
        },
        watch: {
          
        },
        computed: {
          
        },
        methods: {
            isDisabledDate(date) {
                const time = date.getTime();
                const currentTime = new Date().getTime();
                const futureDisabled = this.disabledFutureTime && time > currentTime;
                const startDateDisabled = this.disabledStartDate && time < dayjs(this.disabledStartDate).valueOf();
                const endDateDisabled = this.disabledEndDate && time > dayjs(this.disabledEndDate).valueOf();
                const formerlyCountDisabled = this.disabledFormerlyCount > 0 && time < dayjs().add((-1 * this.disabledFormerlyCount), 'day').valueOf();
                return futureDisabled || startDateDisabled || endDateDisabled || formerlyCountDisabled;
            },
            getShortcuts(obj){
                console.log(obj)
                this.pickerOptions.shortcuts = []
                this.shortcutOptions.map((item,index)=>{
                    if(obj[item]){
                        this.pickerOptions.shortcuts.push(obj[item])
                    }else if(typeof item == "object"){
                        this.pickerOptions.shortcuts.push(item)
                    } 
                })
            },
          //初始化日期选择器快捷键
          initOptions(){
              if(Object.prototype.hasOwnProperty.call(this.propsPickerOptions, 'disabledDate')){
                  this.pickerOptions.disabledDate = this.propsPickerOptions.disabledDate
              }
              if(this.shortcutOptions.length>0){
                  if(this.type == 'datetimerange' || this.type == 'daterange' ){
                      this.getShortcuts(this.datetimerangeOption)
                }else if(this.type == 'datetime' || this.type == 'date'){
                     this.getShortcuts(this.daterangeOption)
                }else if(this.type == 'monthrange'){
                    this.getShortcuts(this.monthrangeOption)
                }
              }
          }
        },
        mounted() {
            this.initOptions()
            
        }
    }
</script>
